export const P = {
  // Seeded by migration 087. Out-of-network claims are billing, not clinical,
  // so they carry their own permissions rather than riding on read_encounter.
  READ_CLAIM: 'read_claim',
  READ_PATIENT: 'read_patient',
  MANAGE_USERS: 'manage_users',
  MANAGE_CLAIM: 'manage_claim',
  SIGN_DOCUMENT: 'sign_document',
  READ_DOCUMENT: 'read_document',
  READ_TEMPLATE: 'read_template',
  SHARE_PATIENT: 'share_patient',
  AMEND_DOCUMENT: 'amend_document',
  CREATE_PATIENT: 'create_patient',
  UPDATE_PATIENT: 'update_patient',

  DELETE_PATIENT: 'delete_patient',
  READ_ENCOUNTER: 'read_encounter',
  UPDATE_DOCUMENT: 'update_document',
  DELETE_DOCUMENT: 'delete_document',
  EXPORT_DOCUMENT: 'export_document',

  UPLOAD_DOCUMENT: 'upload_document',
  CREATE_TEMPLATE: 'create_template',
  UPDATE_TEMPLATE: 'update_template',
  DELETE_TEMPLATE: 'delete_template',
  CREATE_ENCOUNTER: 'create_encounter',

  UPDATE_ENCOUNTER: 'update_encounter',
  DELETE_ENCOUNTER: 'delete_encounter',
  PREPARE_ASSISTANT: 'prepare_assistant',
  GENERATE_DOCUMENT: 'generate_document',

  MANAGE_ORGANIZATION: 'manage_organization',
  // Seeded by migration 113 to every role that already holds share_patient:
  // sending a record to the patient's own app is the same trust as sharing
  // it with them.
  SEND_TO_PATIENT_APP: 'send_to_patient_app',
  READ_UPLOADED_DOCUMENT: 'read_uploaded_document',
  MANAGE_ASSISTANT_POLICY: 'manage_assistant_policy',
  REVIEW_ASSISTANT_ACTIONS: 'review_assistant_actions',

  DELETE_UPLOADED_DOCUMENT: 'delete_uploaded_document',
  EXECUTE_ASSISTANT_ACTIONS: 'execute_assistant_actions',

  MANAGE_SIGNING_ELIGIBILITY: 'manage_signing_eligibility',
} as const;

export type PermissionName = (typeof P)[keyof typeof P];
